import { useEffect } from "react"
import snackbarStyle from "./snackbar.module.css"


export default function SnackBar(props) {

    const id = props['id']
    const text = props['text']

    useEffect(() => {
        const a = setTimeout(() => {
            document.getElementById(id).classList.add(snackbarStyle['on'])
        }, 100)

        return () => {
            clearTimeout(a)
        }
    }, [])

    return(
        <div
            id={id}
            className={snackbarStyle['snackbar']}
        >{text}</div>
    )
}